import { Box, CloseButton, Image, Text } from "@wix/design-system";
import { DataCollection, Document, LargeDesktop } from "@wix/wix-ui-icons-common";
import React from "react";
import classes from "./attachment-bar-scss.js";
const AttachmentBar = ({ attachments, onRemove }) => {
  return /* @__PURE__ */ React.createElement("div", { className: classes.root }, attachments.map((attachment) => {
    if (attachment.status === "loading" || attachment.status === "error") {
      return null;
    }
    if (attachment.fileType === "image") {
      return /* @__PURE__ */ React.createElement("div", { className: classes.attachmentWrapper, key: attachment.id }, /* @__PURE__ */ React.createElement(Image, { src: attachment.url, showBorder: true, width: 46, height: 48 }), /* @__PURE__ */ React.createElement("div", { className: classes.removeButton }, /* @__PURE__ */ React.createElement(
        CloseButton,
        {
          "aria-label": `Delete image`,
          size: "small",
          skin: "standardFilled",
          onClick: () => onRemove(attachment.id)
        }
      )));
    }
    return /* @__PURE__ */ React.createElement(
      Attachment,
      {
        key: attachment.id,
        id: attachment.id,
        fileName: attachment.fileName,
        fileType: attachment.fileType,
        onRemove
      }
    );
  }));
};
const Attachment = ({ id, fileName, fileType, onRemove }) => {
  const { icon, background } = getAttachmentIcon(fileType);
  return /* @__PURE__ */ React.createElement("div", { className: classes.attachmentWrapper }, /* @__PURE__ */ React.createElement(
    Box,
    {
      key: id,
      padding: "SP1",
      gap: "SP2",
      border: "1px solid #DFE5EB",
      borderRadius: "10px",
      minWidth: "200px"
    },
    /* @__PURE__ */ React.createElement(
      Box,
      {
        background,
        borderRadius: "6px",
        height: "36px",
        width: "36px",
        align: "center",
        verticalAlign: "middle"
      },
      icon
    ),
    /* @__PURE__ */ React.createElement(Box, { direction: "vertical" }, /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "normal" }, fileName), /* @__PURE__ */ React.createElement(Text, { size: "tiny", weight: "thin" }, fileType.toUpperCase()))
  ), /* @__PURE__ */ React.createElement("div", { className: classes.removeButton }, /* @__PURE__ */ React.createElement(
    CloseButton,
    {
      "aria-label": `Delete ${fileName}`,
      size: "small",
      skin: "standardFilled",
      onClick: () => onRemove(id)
    }
  )));
};
const getAttachmentIcon = (fileType) => {
  switch (fileType) {
    case "pdf":
      return {
        icon: /* @__PURE__ */ React.createElement(Document, { color: "#fff" }),
        background: "#E62214"
      };
    case "doc":
      return {
        icon: /* @__PURE__ */ React.createElement(Document, { color: "#fff" }),
        background: "#116DFF"
      };
    case "sheet":
      return {
        icon: /* @__PURE__ */ React.createElement(DataCollection, { color: "#fff" }),
        background: "#25A55A"
      };
    case "slides":
      return {
        icon: /* @__PURE__ */ React.createElement(LargeDesktop, { color: "#000" }),
        background: "#FFB700"
      };
    default:
      return {
        icon: /* @__PURE__ */ React.createElement(Document, { color: "#000" }),
        background: "#ECEFF3"
      };
  }
};
export {
  AttachmentBar
};
//# sourceMappingURL=attachment-bar.js.map
